import { ILog } from "./ILog";
import { LogLevel } from "./LogLevel";

export class CompositeLogProvider implements ILog {
    private _logProviders: ILog[];
    private _loggingLevels: LogLevel[];

    constructor(logProviders: ILog[], loggingLevels: LogLevel[]) {
        this._logProviders = logProviders;
        this._loggingLevels = loggingLevels;
    }

    log(type: string, level: LogLevel, ...messages: string[]): void {
        if (this._loggingLevels.indexOf(level) !== -1) this._logProviders.map((lp) => lp.log(type, level, ...messages));
    }
}
